define(["require", "exports", "tslib", "../../constants", "../../store/Events", "../../utils/LocalStorage", "../../utils/UrlUtil", "./EventManager", "./ServiceError"], function (require, exports, tslib_1, constants_1, Events_1, LocalStorage_1, UrlUtil_1, EventManager_1, ServiceError_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ServiceBase = void 0;
    class ServiceBase {
        constructor(serviceResource, protocol, host, serviceName, proxyUrl) {
            Object.defineProperty(this, "serviceResourceName", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "url", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "proxyUrl", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.serviceResourceName = serviceResource;
            this.url = (0, UrlUtil_1.buildUrl)(protocol, host, serviceName, serviceResource);
            this.proxyUrl = proxyUrl ? proxyUrl + "?" : "";
        }
        get(endpoint, callback, opts) {
            return this.request("GET", endpoint, null, callback, opts);
        }
        post(endpoint, params, callback, opts) {
            return this.request("POST", endpoint, params, callback, opts);
        }
        delete(endpoint, params, callback, opts) {
            return this.request("DELETE", endpoint, params, callback, opts);
        }
        request(method, endpoint, params, callback, opts) {
            return new Promise((resolve, reject) => {
                EventManager_1.EventManager.Instance.emit(Events_1.SERVICE_REQUEST_INIT, endpoint);
                fetch(`${this.proxyUrl}${this.url}/${endpoint}`, this.makeOpts(method, params, opts))
                    .then(this.parseResponse)
                    .then((json) => {
                    EventManager_1.EventManager.Instance.emit(Events_1.SERVICE_REQUEST_SUCCESS, endpoint);
                    resolve(callback(json));
                })
                    .catch(err => {
                    var _a;
                    const ex = err instanceof ServiceError_1.ServiceError ? err : new ServiceError_1.ServiceError(err.Message);
                    ex.Code = err.Code || err.statusCode;
                    ex.Service = this.serviceResourceName;
                    ex.Method = endpoint;
                    ex.StackTrace = err.StackTrace;
                    ex.Inputs = err.Inputs || params;
                    ex.Level = (_a = err.Level) !== null && _a !== void 0 ? _a : ServiceError_1.ServiceErrorLevel.Error;
                    EventManager_1.EventManager.Instance.emit(Events_1.SERVICE_REQUEST_ERROR, endpoint, ex);
                    reject(ex);
                });
            });
        }
        requestFile(endpoint, params) {
            return new Promise((resolve, reject) => {
                EventManager_1.EventManager.Instance.emit(Events_1.SERVICE_REQUEST_INIT, endpoint);
                try {
                    window.open(`${this.proxyUrl}${this.url}/${endpoint}?${this.paramsToUrlEncodedString(params)}`, "_blank");
                    EventManager_1.EventManager.Instance.emit(Events_1.SERVICE_REQUEST_SUCCESS, endpoint);
                    resolve();
                }
                catch (err) {
                    const ex = new ServiceError_1.ServiceError(err.Message);
                    ex.Service = this.serviceResourceName;
                    ex.Method = endpoint;
                    ex.StackTrace = err.StackTrace;
                    ex.Code = err.Code;
                    ex.Inputs = err.Inputs || params;
                    ex.Level = err.Level || ServiceError_1.ServiceErrorLevel.Error;
                    EventManager_1.EventManager.Instance.emit(Events_1.SERVICE_REQUEST_ERROR, endpoint, ex);
                    reject(ex);
                }
            });
        }
        makeOpts(method, params, overrides) {
            const { sendAsForm } = overrides || {};
            const opts = {
                method,
                mode: "cors",
                headers: {
                    Accept: "application/json"
                }
            };
            const token = (0, LocalStorage_1.getLocalStorageValue)(constants_1.USER_TOKEN);
            if (token) {
                opts.headers.Authorization = `Bearer ${token}`;
            }
            if (method == "POST" || method == "PUT") {
                opts.headers["Content-Type"] = sendAsForm ? "application/x-www-form-urlencoded" : "application/json";
                if (params) {
                    opts.body = sendAsForm ? this.paramsToUrlEncodedString(params) : JSON.stringify(params);
                }
            }
            return opts;
        }
        paramsToUrlEncodedString(params) {
            const pArray = [];
            let val;
            for (const p in params) {
                if (params.hasOwnProperty(p)) {
                    if (typeof params[p] === "object") {
                        val = encodeURIComponent(JSON.stringify(params[p]));
                    }
                    else {
                        val = encodeURIComponent(params[p]);
                    }
                    pArray.push(`${p}=${val}`);
                }
            }
            return pArray.join("&");
        }
        parseResponse(response) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (response.status >= 200 && response.status < 300) {
                    const json = yield response.json();
                    if (json.hasOwnProperty("result")) {
                        return json.result;
                    }
                    else {
                        return json;
                    }
                }
                else if (response.status >= 400 && response.status < 500) {
                    const json = yield response.json();
                    const err = new ServiceError_1.ServiceError(json.detail);
                    err.Code = response.status;
                    err.Level = ServiceError_1.ServiceErrorLevel.Error;
                    throw err;
                }
                else if (response.status == 500) {
                    const json = yield response.json();
                    const err = new ServiceError_1.ServiceError(json.message);
                    err.Code = response.status;
                    err.Level = json.level || ServiceError_1.ServiceErrorLevel.Error;
                    err.Inputs = json.inputs;
                    err.StackTrace = json.stackTrace;
                    throw err;
                }
                else {
                    const err = new ServiceError_1.ServiceError(response.statusText);
                    err.Code = response.status;
                    err.Level = ServiceError_1.ServiceErrorLevel.Error;
                    err.Response = response;
                    console.error(err);
                    throw err;
                }
            });
        }
    }
    exports.ServiceBase = ServiceBase;
});
